<div class="login2background" style="background-image: url(assets/img/global/fundo_login.jpg)">
  <div class="main-content container-fluid">
    <div class="splash-container">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <img src="assets/img/global/thumb_up.png" alt="ok">
              <span class="float-right"><b>Uma senha temporária foi enviada para o e-mail cadastrado.</b> Após login altere a senha para uma de sua preferência.</span>
            </div>
          </div>
          <div class="row mt-4">
              <div class="col-12">
                <button type="button" (click)="voltar()" class="btn btn-link btn-sm float-right mr-3">Voltar para tela de login</button>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
